import {all, takeEvery, put, call, select} from 'redux-saga/effects';
import actions from "./actions";
import {getEmployeeDocumentApi, getEmployeeDocumentsApi} from "../../services/employee_documents.service";
import {ReducerType} from "../reducer.type";
import { AxiosResponse } from 'axios';
import { ClientInterface, ClientWorkspace } from '../client/client.type';

const getWorkspace = (state: ReducerType) => state.client.owner.workspace;
const getClient = (state: ReducerType) => state.client.owner;

export function* GET_ALL_CLIENT_EMPLOYEE_DOCUMENTS(action: {payload: string, type: string}) {
    try {
        const workspace: ClientWorkspace = yield select(getWorkspace);
        const client: ClientInterface = yield select(getClient);

        const response: AxiosResponse<any> = yield call(
          getEmployeeDocumentsApi,
          workspace.uuid,
          client.uuid,
          action.payload
        );
        if (response.data) {
            yield put({
                type: actions.SET_CLIENT_EMPLOYEE_DOCUMENTS,
                payload: response.data
            })
        }
    } catch (e) {}
}

export function* GET_CLIENT_EMPLOYEE_DOCUMENT(action: {payload: any, type: string}) {
    try {
        const workspace: ClientWorkspace = yield select(getWorkspace);
        const client: ClientInterface = yield select(getClient);

        const response: AxiosResponse<any> = yield call(
          getEmployeeDocumentApi,
          workspace.uuid,
          client.uuid,
          action.payload.employee,
          action.payload.document
        );
        if (response.data) {
            yield put({
                type: actions.SET_CLIENT_EMPLOYEE_DOCUMENT,
                payload: response.data
            })
        }
    } catch (e) {}
}

export default function* rootSaga() {
    yield all([
        takeEvery(actions.GET_CLIENT_EMPLOYEE_DOCUMENTS, GET_ALL_CLIENT_EMPLOYEE_DOCUMENTS),
        takeEvery(actions.GET_CLIENT_EMPLOYEE_DOCUMENT, GET_CLIENT_EMPLOYEE_DOCUMENT),
    ])
}
